import { HttpClient } from './interceptor';

export class CommonApi{
    
    // 获取logo、slogan以及标题
    static getLogoSlogan = () => {
        return new Promise(resolve => {
            HttpClient.post('/api/LoginController/isLoginImage', {}).then(res => {
                if(res.data.status === 200){
                    resolve(res.data.content);
                }
            }).catch(err => console.log(err));
        })
    }


    // 登录
    static login = (param) => {
        return new Promise(resolve => {
            HttpClient.post('/api/LoginController/login', param).then(res => {
                resolve(res);
            }).catch(err => console.log(err));
        })
    }

    // 验证密码
    static verifyPassword = (param) => {
        return new Promise(resolve => {
            HttpClient.post('/api/LoginController/checkUserAccount', param).then(res => {
                resolve(res.data.content);
            }).catch(err => console.log(err));
        })
    }

    // 修改密码
    static updatePassword = (param) => {
        return new Promise(resolve => {
            HttpClient.post('/api/LoginController/updatePassword', param).then(res => {
                resolve(res);
            }).catch(err => console.log(err));
        })
    }

    // 登出
    static logout = () => {
        return new Promise(resolve => {
            HttpClient.post('/api/LoginController/logout', {}).then(res => {
                resolve(res);
            }).catch(err => console.log(err));
        })
    }

    // 获取菜单
    static getMenuList = () => {
        return new Promise((resolve) => {
            HttpClient.post('/api/FunTreeController/getFunTree', {}).then(res => {
                if(res.data.status === 200)
                    resolve(res.data.content);
            });
        });
    }

    // 获取门店下拉
    static getStoreSelectorList = () => {
        return new Promise((resolve) => {
            HttpClient.post('/api/storeController/getStoreSelect', {}).then(res => {
                if(res.data.status === 200)
                    resolve(res.data.content);
            });
        })
    }

    static getRoleSelectorList = () => {
        return new Promise((resolve) => {
            HttpClient.post('/api/RoleController/getRoleSelect', {}).then(res => {
                if(res.data.status === 200)
                    resolve(res.data.content);
            });
        })
    }

}